export default {
  'landing.memory': 'Machen Sie Ihre Erinnerungen mit uns',
  'landing.family':
    'Erleben Sie die besten Reisen mit Ihrer Familie und Freunden',
  'landing.providing':
    'Bereitstellung aller Flüge und des einfachsten Prozesses zum Suchen, Kaufen und Erstatten von Flugtickets',
  'landing.price':
    'Der niedrigste Preis für den Kauf von Flugtickets mit Sonderrabatt',
  'landing.point': 'Bei jeder Fahrt Punkte sammeln',
  'landing.buynow': 'Jetzt kaufen',
  'landing.scotland': 'Reise nach Schottland',
  'landing.ireland': 'Reise nach Irland',
  'landing.egypt': 'Reise nach Ägypten',
  'landing.greece': 'Reise nach Griechenland',
  'landing.person': 'einige Leute sind gegangen',
  'landing.categories': 'Kategorien',
};
